@if (showNav()) {
  <!-- desktop layout -->
  @if (!onMobileScreen) {
    <div>
      <div class="border-bottom border-mute border-2 d-flex align-middle"
        [ngClass]="{ 'justify-content-center': !showTitles, 'imgContainer': showTitles, 'imgContainerMinimized': !showTitles }"
        [routerLink]="getLogoUrl()"
        style="cursor: pointer;">
        @if (showTitles) {
          <img src="assets/img/logo.svg" alt="Everon" style="height: 58px;">
        }
        @if (!showTitles) {
          <img src="assets/img/logo_monogram.svg" style="height: 40px;">
        }
      </div>
      @if (!showCrClocks()) {
        <button (click)="onShowOrHideTitles()" aria-label="Show and hide names of navigation links"
          class="badge rounded-circle text-dark bg-light btn-sm chevronButton"
          >
          @if (!showTitles) {
            <mat-icon>chevron_right</mat-icon>
          }
          @if (showTitles) {
            <mat-icon>chevron_left</mat-icon>
          }
        </button>
      }
    </div>
  }
  <!-- mobile layout -->
  @if (onMobileScreen) {
    <div [ngStyle]="{'margin-bottom': '15px'}" class="d-flex">
      <div class="flex-grow-1">
        <app-logout-options
          [language]="language"
          [user]="user"
          [landingPageUser]="landingPageUser"
          [loggedCustomer]="loggedCustomer"
          [loginButtonStyle]="positionLeft"
          [logoutBtnForMobileSidenav]=true>
        </app-logout-options>
      </div>
      <button (click)="onSideNavClose()" mat-mini-fab color="primary" class="closeBtn"
        aria-label="Close navigation bar">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
}
